/**
 * Safely write text to the clipboard, suppressing NotAllowedError
 * when the document is not focused (e.g. popout widgets, background tabs).
 */
export async function safeClipboardWrite(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
}
